import Model from "./Model";

class Contact extends Model {
    getId() {
        return this.attrs.id;
    }
    
    setId(value) {
        this.attrs.id = value;
        return this;
    }
    getPhoneNumber() {
        return this.attrs.phoneNumber;
    }
    
    setPhoneNumber(value) {
        this.attrs.phoneNumber = value;
        return this;
    }
    getName() {
        return this.attrs.name;
    }
    
    setName(value) {
        this.attrs.name = value;
        return this;
    }
    getEmail() {
        return this.attrs.email;
    }
    
    setEmail(value) {
        this.attrs.email = value;
        return this;
    }
    getCompany() {
        return this.attrs.company;
    }
    
    setCompany(value) {
        this.attrs.company = value;
        return this;
    }
    getPosition() {
        return this.attrs.position;
    }
    
    setPosition(value) {
        this.attrs.position = value;
        return this;
    }
    getTags() {
        return this.attrs.tags;
    }
    
    setTags(value) {
        this.attrs.tags = value;
        return this;
    }
    getNotes() {
        return this.attrs.notes;
    }
    
    setNotes(value) {
        this.attrs.notes = value;
        return this;
    }
    getAddress() {
        return this.attrs.address;
    }
    
    setAddress(value) {
        this.attrs.address = value;
        return this;
    }
    getWebsite() {
        return this.attrs.website;
    }
    
    setWebsite(value) {
        this.attrs.website = value;
        return this;
    }
    getBirthday() {
        return this.attrs.birthday;
    }
    
    setBirthday(value) {
        this.attrs.birthday = value;
        return this;
    }
    getSource() {
        return this.attrs.source;
    }
    
    setSource(value) {
        this.attrs.source = value;
        return this;
    }
    getStatus() {
        return this.attrs.status;
    }
    
    setStatus(value) {
        this.attrs.status = value;
        return this;
    }
    getCreatedAt() {
        return this.attrs.createdAt;
    }
    
    setCreatedAt(value) {
        this.attrs.createdAt = value;
        return this;
    }
}
export default Contact;